import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import 'bootstrap/dist/css/bootstrap.min.css';
import { showMyAlert } from "../../Utils/alertService";

const Login = () => {
  const navigate = useNavigate();
  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [forgotPasswordModalVisible, setForgotPasswordModalVisible] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotPasswordLoading, setForgotPasswordLoading] = useState(false);
  const [forgotPasswordMessage, setForgotPasswordMessage] = useState("");

  const API_ENDPOINT = "https://api.dremerz.net/api/DZ_8922_EmpAttendance_Registration_RegistrationUsers";

  const handlePasswordReset = async () => {
    if (!forgotEmail) {
      setForgotPasswordMessage("Please enter your email address.");
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(forgotEmail)) {
      setForgotPasswordMessage("Please enter a valid email address.");
      return;
    }

    setForgotPasswordLoading(true);
    setForgotPasswordMessage("");

    try {
      const { data } = await axios.get(API_ENDPOINT);
      
      const user = data.find((u) => u.email === forgotEmail);

      if (!user) {
        setForgotPasswordMessage("Email address not registered.");
        setForgotPasswordLoading(false);
        return;
      }

      // If email exists, redirect to password reset URL with email as parameter
      const resetUrl = `https://emailjs-connector.netlify.app/reset-password?email=${forgotEmail}`;
      
      // Open the URL in new tab
      window.open(resetUrl, '_blank');

      setForgotPasswordMessage("Redirecting to password recovery page...");
      setForgotEmail("");
      setTimeout(() => {
        setForgotPasswordModalVisible(false);
      }, 1000);
      
    } catch (error) {
      console.error("Error processing password reset:", error);
      setForgotPasswordMessage("An error occurred. Please try again later.");
    } finally {
      setForgotPasswordLoading(false);
    }
  };

  const validateInputs = () => {
    if (!mobileNumber.trim()) {
            showMyAlert({
  type: "warning",              // "success" | "danger" | "warning" | "info"
  title: "Warning",
  message: "Please enter your mobile number",
  duration: 2500,               // auto-close in 2.5s
});
      return false;
    }

    if (!password.trim()) {
                  showMyAlert({
  type: "warning",              // "success" | "danger" | "warning" | "info"
  title: "Warning",
  message: "Please enter your password",
  duration: 2500,               // auto-close in 2.5s
});

      return false;
    }

    if (mobileNumber.length < 10) {
                  showMyAlert({
  type: "warning",              // "success" | "danger" | "warning" | "info"
  title: "Warning",
  message: "Please enter a valid mobile number",
  duration: 2500,               // auto-close in 2.5s
});

      return false;
    }

    return true;
  };

  const handleLogin = async () => {
    if (!validateInputs()) return;

    setIsLoading(true);

    try {
      const response = await fetch(API_ENDPOINT);

      if (!response.ok) {
        throw new Error(`Network error: ${response.status}`);
      }

      const users = await response.json();

      if (!Array.isArray(users)) {
        throw new Error("Invalid response format from server");
      }

      const user = users.find(
        (user) =>
          (user.mobile_number === mobileNumber ||
            user.phone_number === mobileNumber) &&
          user.password === password
      );

      if (user) {
        if (
          user.approval_status === "false" ||
          user.approval_status === false
        ) {
          throw new Error(
            "Your account is not yet approved. Please contact your administrator."
          );
        }

        const normalizedUser = {
          ...user,
          mobile_number: user.mobile_number || user.phone_number,
          phone_number: user.phone_number || user.mobile_number,
          approval_status: user.approval_status,
        };

        // Store in localStorage instead of AsyncStorage
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("userId", user.id.toString());
        localStorage.setItem("userData", JSON.stringify(normalizedUser));
        localStorage.setItem("userMobileNumber", normalizedUser.mobile_number);
        localStorage.setItem("userEmployeeId", user.employee_id || "");

        const savedUserId = localStorage.getItem("userId");
        const savedUserData = localStorage.getItem("userData");

        if (!savedUserId || !savedUserData) {
          throw new Error("Failed to save user session data");
        }

                    showMyAlert({
  type: "success",              // "success" | "danger" | "warning" | "info"
  title: "Logged In",
  message: "Login Successfull",
  duration: 2500,               // auto-close in 2.5s
});
        navigate("/empdetails");
      } else {
                    showMyAlert({
  type: "danger",              // "success" | "danger" | "warning" | "info"
  title: "Invalid Data",
  message: "Invalid mobile number or password. Please check your credentials and try again",
  duration: 2500,               // auto-close in 2.5s
});

      }
    } catch (error) {
      console.error("Login error:", error);
      let errorMessage = "Login failed. Please try again.";

      if (error.message.includes("Network")) {
        errorMessage = "Network error. Please check your internet connection.";
      } else if (error.message.includes("server")) {
        errorMessage = "Server error. Please try again later.";
      } else if (error.message.includes("approved")) {
        errorMessage = error.message;
      }

                  showMyAlert({
  type: "warning",              // "success" | "danger" | "warning" | "info"
  title: "Warning",
  message: errorMessage,
  duration: 2500,               // auto-close in 2.5s
});
    } finally {
      setIsLoading(false);
    }
  };

  const formatMobileNumber = (text) => {
    const cleaned = text.replace(/\D/g, "");
    return cleaned.slice(0, 15);
  };

  return (
    <div className="container-fluid vh-100 d-flex align-items-center justify-content-center bg-white">
      <div className="row w-100 justify-content-center">
        <div className="col-12 col-md-6 col-lg-4">
          <div className="card shadow-sm border-0">
            <div className="card-body p-4">
              {/* Header Section */}
              <div className="text-center mb-4">
                <h2 className="fw-bold text-dark mb-2">Welcome Back</h2>
                <p className="text-muted">Login to access your employee dashboard</p>
              </div>

              {/* Form Section */}
              <form onSubmit={(e) => { e.preventDefault(); handleLogin(); }}>
                {/* Mobile Number */}
                <div className="mb-3">
                  <label className="form-label fw-semibold text-dark">Mobile Number</label>
                  <div className="input-group">
                    <span className="input-group-text bg-light border-end-0">
                      <i className="fas fa-phone text-muted"></i>
                    </span>
                    <input
                      type="tel"
                      className="form-control border-start-0 bg-light"
                      placeholder="Enter your mobile number"
                      value={mobileNumber}
                      onChange={(e) => setMobileNumber(formatMobileNumber(e.target.value))}
                      maxLength={15}
                    />
                  </div>
                </div>

                {/* Password */}
                <div className="mb-3">
                  <label className="form-label fw-semibold text-dark">Password</label>
                  <div className="input-group">
                    <span className="input-group-text bg-light border-end-0">
                      <i className="fas fa-lock text-muted"></i>
                    </span>
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control border-start-0 border-end-0 bg-light"
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary border-start-0 bg-light"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'} text-muted`}></i>
                    </button>
                  </div>
                </div>

                {/* Forgot Password */}
                <div className="text-end mb-3">
                  <button
                    type="button"
                    className="btn btn-link p-0 text-dark fw-semibold text-decoration-none"
                    onClick={() => setForgotPasswordModalVisible(true)}
                  >
                    Forgot Password?
                  </button>
                </div>

                {/* Login Button */}
                <button
                  type="submit"
                  className="btn btn-dark w-100 py-2 fw-bold"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                      Logging in...
                    </>
                  ) : (
                    "Log In"
                  )}
                </button>
              </form>

              {/* Footer Section */}
              <div className="text-center mt-4">
                <span className="text-muted">Don't have an account? </span>
                <button
                  type="button"
                  className="btn btn-link p-0 text-dark fw-bold text-decoration-none"
                  onClick={() => navigate("/Registration")}
                >
                  Register Here
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Forgot Password Modal */}
      {forgotPasswordModalVisible && (
        <div className="modal show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title fw-bold">Forgot Password</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setForgotPasswordModalVisible(false);
                    setForgotEmail("");
                    setForgotPasswordMessage("");
                  }}
                ></button>
              </div>
              <div className="modal-body">
                <p className="text-muted mb-3">
                  Enter your email address and we'll redirect you to the password recovery page.
                </p>

                <div className="mb-3">
                  <label className="form-label fw-semibold">Email Address</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter your email address"
                    value={forgotEmail}
                    onChange={(e) => setForgotEmail(e.target.value)}
                  />
                </div>

                {forgotPasswordMessage && (
                  <div className={`alert ${forgotPasswordMessage.includes("Redirecting") ? 'alert-info' : 'alert-danger'} text-center`}>
                    {forgotPasswordMessage}
                  </div>
                )}

                <button
                  type="button"
                  className="btn btn-dark w-100 py-2 fw-bold"
                  onClick={handlePasswordReset}
                  disabled={forgotPasswordLoading}
                >
                  {forgotPasswordLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                      Checking...
                    </>
                  ) : (
                    "Get My Password"
                  )}
                </button>

                <p className="text-muted text-center mt-3 small">
                  You'll be redirected to our secure password recovery page.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;